import React from 'react'

/**
 * Thin vertical line between groups of items in a bar, such as the buttons and the weather on the
 * kiosk screen
 * @returns {JSX.Element} divider
 */
const Divider = () => <span className="bar-divider" aria-hidden="true"/>

export default Divider
